<div id="layoutSidenav">
    <div id="layoutSidenav_content">

        <div class="container-fluid px-5 pt-5 mt-4">
            <div class="leads-btns d-flex justify-content-end mb-3">
                <div class="position-relative">
                  <input
                    type="text"
                    ngbDatepicker
                    #calendar="ngbDatepicker"
                    [(ngModel)]="model"
                    class="form-control"
                    style="position: absolute; width: 0; height: 0; opacity: 0; border: none; pointer-events: none;"
                  />
                  <button class="btn btn-outline-light" (click)="calendar.toggle()">
                    Calendar <i class="fa-solid fa-calendar-days"></i>
                  </button>
                </div>
              </div>
            <!-- Total Leads Section -->
            <!-- Coupon Banner -->


            <h2 class="mb-2 text-danger">Billing</h2>

            <!-- <div style="float: right;">
                <button type="button" class="btn btn-primary">Add Service Partner</button>
            </div> -->

            <!-- Data Table -->
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead class="table-primary">
                        <tr>

                            <th>S.No</th>
                            <th>MM/YY</th>
                            <th>PropTech Bill<br />
                                (A)</th>
                            <th>Fintech Bill<br />
                                (B)</th>
                            <th> Prop Services Bill <br />(C)</th>
                            <th>Total Bill =<br />
                                (A + B + C)</th>
                            <th>MFU Share</th>
                            <th>PB Share</th>
                            <th>Settled On</th>
                            <th>Approval</th>
                        </tr>
                    </thead>
                    <ng-container *ngFor="let bill of billing; let i = index">
                        <tr style="cursor: pointer;" (click)="toggleRow(i)">
                            <td>{{ i+1 }}</td>
                            <td>{{ bill.month}}/ {{bill.year}}</td>
                            <td>{{bill.totalCommission}}</td>
                            <td>{{0}}</td>
                            <td>{{0}}</td>
                            <td>{{bill.totalCommission}}</td>
                            <td>{{bill.totalMfuShare}}</td>
                            <td>{{bill.totalPbShare}}</td>
                            <td>-</td>
                            <td>-</td>
                        </tr>
                        <!-- <ng-container *ngIf="expandedIndex === i">
                            <tr>
                                <td colspan="12" class="bg-light">
                                    <div class="p-2 border w-75 bg-white rounded-1 m-auto text-wrap td-data">
                                        <a (click)="toggleRow(i)" style="cursor:pointer;"><i
                                                class="fa-solid fa-chevron-up text-right d-block mb-2"></i> </a>
                                        <p *ngFor="let mess of bill.message" class="mb-1">
                                            <b>{{mess.message}}:</b>
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        </ng-container> -->

                    </ng-container>

                </table>
            </div>
        </div>

    </div>
</div>